/**
 * 添加活动表单组件
 */

import React from 'react';
import { Space, Select, InputNumber, Button, Typography } from 'antd';
import type { MarketingActivityType, VineMarketplace } from '../../../ProfitScenario/types/marketingActivities';
import { ACTIVITY_OPTIONS, MARKETPLACE_OPTIONS } from './constants';
import { getUnitsLabel, getMaxUnits } from './utils';

const { Text } = Typography;

interface NewActivityState {
    type: MarketingActivityType;
    units: number;
    marketplace: VineMarketplace;
    videoCostPerUnit: number;
    slotFee: number;
}

interface AddActivityFormProps {
    newActivity: NewActivityState;
    onActivityChange: (activity: NewActivityState) => void;
    onAdd: () => void;
}

export const AddActivityForm: React.FC<AddActivityFormProps> = ({ newActivity, onActivityChange, onAdd }) => {
    return (
        <div style={{ width: 280 }}>
            <Space direction="vertical" style={{ width: '100%' }} size="small">
                <div>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        活动类型
                    </Text>
                    <Select
                        value={newActivity.type}
                        onChange={type => onActivityChange({ ...newActivity, type })}
                        options={ACTIVITY_OPTIONS}
                        style={{ width: '100%', marginTop: 4 }}
                        size="small"
                    />
                </div>

                {newActivity.type === 'vine' && (
                    <div>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            站点
                        </Text>
                        <Select
                            value={newActivity.marketplace}
                            onChange={marketplace => onActivityChange({ ...newActivity, marketplace })}
                            options={MARKETPLACE_OPTIONS}
                            style={{ width: '100%', marginTop: 4 }}
                            size="small"
                        />
                    </div>
                )}

                <div>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        {getUnitsLabel(newActivity.type)}
                    </Text>
                    <InputNumber
                        value={newActivity.units}
                        onChange={v => onActivityChange({ ...newActivity, units: v || 1 })}
                        min={1}
                        max={getMaxUnits(newActivity.type)}
                        style={{ width: '100%', marginTop: 4 }}
                        size="small"
                    />
                </div>

                {newActivity.type === 'influencer' && (
                    <div>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            单个视频费用
                        </Text>
                        <InputNumber
                            value={newActivity.videoCostPerUnit}
                            onChange={v => onActivityChange({ ...newActivity, videoCostPerUnit: v || 0 })}
                            prefix="$"
                            min={0}
                            style={{ width: '100%', marginTop: 4 }}
                            size="small"
                        />
                    </div>
                )}

                {newActivity.type === 'product_seeding' && (
                    <div>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            坑位费
                        </Text>
                        <InputNumber
                            value={newActivity.slotFee}
                            onChange={v => onActivityChange({ ...newActivity, slotFee: v || 0 })}
                            prefix="$"
                            min={0}
                            style={{ width: '100%', marginTop: 4 }}
                            size="small"
                        />
                    </div>
                )}

                <Button type="primary" size="small" onClick={onAdd} block>
                    添加
                </Button>
            </Space>
        </div>
    );
};
